import { IContent } from '~src/spacesPlatform/models/IContent';

import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../../httpClient/serverApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../httpClient/serverApi/types/IGetItemsResult';
import { IUser } from '../../../userManagement/users/serverApi/types/IUser';

export interface IGetContentForUserResult extends IGetItemsResult {
  content: IContent[];
  users: IUser[];
}

export class GetContentForUserRequest extends Request<IGetItemsParams, IGetContentForUserResult> {
  constructor(params: IGetItemsParams) {
    super('getContentForUser', params);
  }
}
